const breederLitterManagementFilters = {
    state: {
      filters: {}
    },
    mutations: {
      // Mutation to set a filter based on the label
      setBreederLitterManagementFilters(state, { label, value }) {
        state.filters[label] = value;
      },
      resetBreederLitterManagementFilters(state) {
        state.filters = {};
      }
    },
    actions: {
      // Action to apply a filter
      applyBreederLitterManagementFilters({ commit }, { label, value }) {
        commit('setBreederLitterManagementFilters', { label, value });
      },
      resetBreederLitterManagementFilters({ commit }) {
        commit('resetBreederLitterManagementFilters');
      }
    },
    getters: {
      getBreederLitterManagementFilters: (state) => (label) => {
        return state.filters[label] || null;
      }
    }
  };
  
  export default breederLitterManagementFilters;
  